module.exports = __webpack_public_path__ + "static/media/37.8f74c518.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/37.svg
// module id = 407
// module chunks = 14